import images from "../data/siteImageAssets.json";

if (!process.env.REACT_APP_BACKEND_URL) throw new Error("REACT_APP_BACKEND_URL is required");
export const siteImage = (source) => {
  if (!images[source]) throw new Error(`Unknown site image: ${source}`);
  return new URL(images[source], process.env.REACT_APP_BACKEND_URL).href;
};
export const HERO_IMAGE = siteImage("/media/home-hero.webp");
export const LOGO_IMAGE = siteImage("/media/categories/logo.webp");
export const CATEGORY_IMAGES = Object.fromEntries(
  ["alcohol", "soft_drinks", "water", "snacks", "planches", "tobacco"].map((name) =>
    [name, siteImage(`/media/categories/${name}.webp`)]
  )
);